/**
 * @generated SignedSource<<75e2f8da207eb36e0a0e44b893ded4a0>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';

export type AddressCellFragment$data = {
  readonly id: string;
  readonly locality: string;
  readonly primaryAddressLine: string;
  readonly secondaryAddressLine: string | null;
  readonly subdivision: string;
  readonly zip: string;
  readonly ' $fragmentType': 'AddressCellFragment';
};
export type AddressCellFragment$key = {
  readonly ' $data'?: AddressCellFragment$data;
  readonly ' $fragmentSpreads': FragmentRefs<'AddressCellFragment'>;
};

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'AddressCellFragment',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'primaryAddressLine',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'secondaryAddressLine',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'locality',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'subdivision',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'zip',
      storageKey: null,
    },
  ],
  type: 'Address',
  abstractKey: null,
};

(node as any).hash = '548622ff080e74b82014f8a7c8a3b7d4';

export default node;
